import { Action } from '@ngrx/store';
import { TConfigSetupActionType } from './config-setup.models';
import {
  TListingFetchReason,
  TRESPONSE_HOLIDAY_LIST,
  TREQUEST_ADD_HOLIDAYS,
  TREQUEST_DELETE_HOLIDAYS,
  TFilterSelected,
  TREQUEST_EDIT_HOLIDAY,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export class GetHolidayListInfo implements Action {
  readonly type = TConfigSetupActionType.GetHolidayList;
  constructor(public fetchReason: TListingFetchReason, public selectedFilters: TFilterSelected[]) {}
}
export class GetHolidayListInfoSuccess implements Action {
  readonly type = TConfigSetupActionType.GetHolidayListSuccess;
  constructor(public holidayListRes: TRESPONSE_HOLIDAY_LIST, public fetchReason: TListingFetchReason) {}
}
export class GetHolidayListInfoFailure implements Action {
  readonly type = TConfigSetupActionType.GetHolidayListFailure;
}

export class SetHolidayListPagination implements Action {
  readonly type = TConfigSetupActionType.SetHolidayListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class AddHolidays implements Action {
  readonly type = TConfigSetupActionType.AddHolidays;
  constructor(public holidays: TREQUEST_ADD_HOLIDAYS) {}
}
export class AddHolidaysSuccess implements Action {
  readonly type = TConfigSetupActionType.AddHolidaysSuccess;
}
export class AddHolidaysFailure implements Action {
  readonly type = TConfigSetupActionType.AddHolidaysFailure;
}

export class DeleteHolidays implements Action {
  readonly type = TConfigSetupActionType.DeleteHolidays;
  constructor(public holidays: TREQUEST_DELETE_HOLIDAYS) {}
}
export class DeleteHolidaysSuccess implements Action {
  readonly type = TConfigSetupActionType.DeleteHolidaysSuccess;
}
export class DeleteHolidaysFailure implements Action {
  readonly type = TConfigSetupActionType.DeleteHolidaysFailure;
}

export class EditHoliday implements Action {
  readonly type = TConfigSetupActionType.EditHoliday;
  constructor(public holiday: TREQUEST_EDIT_HOLIDAY) {}
}
export class EditHolidaySuccess implements Action {
  readonly type = TConfigSetupActionType.EditHolidaySuccess;
}
export class EditHolidayFailure implements Action {
  readonly type = TConfigSetupActionType.EditHolidayFailure;
}

export type TConfigSetupActions =
  | GetHolidayListInfo
  | GetHolidayListInfoSuccess
  | GetHolidayListInfoFailure
  | SetHolidayListPagination
  | AddHolidays
  | AddHolidaysSuccess
  | AddHolidaysFailure
  | DeleteHolidays
  | DeleteHolidaysSuccess
  | DeleteHolidaysFailure
  | EditHoliday
  | EditHolidaySuccess
  | EditHolidayFailure;
